import SharedAmocrmLicensesCost from "../classes/SharedAmocrmLicensesCost";

const defaultState = () => ({
  data: [],
  filter_string: ""
});

const state = defaultState();

const getters = {
  licenses: () => {
    return state.filter_string
      ? state.data.filter(v => v.beShownForFilterString(state.filter_string))
      : state.data;
  },
  nameExist: () => (name, uuid) => {
    return state.data
      .reduce((r, v) => {
        if (v.uuid === uuid) {
          return r;
        }
        r.push(v.tariff_name);
        return r;
      }, [])
      .includes(name);
  }
};

const actions = {
  getData(state, variables = {}) {
    return SharedAmocrmLicensesCost.getDataList(variables);
  },
  shared_amocrm_licenses_cost_list(state, data) {
    state.commit("setData", JSON.parse(JSON.stringify(data)));
  }
};

const mutations = {
  resetState(state) {
    Object.assign(state, defaultState());
  },
  setData(state, data) {
    state.data = SharedAmocrmLicensesCost.getSelfList(data);
  },
  addFirst(state) {
    state.filter_string = "";
    state.data.unshift(new SharedAmocrmLicensesCost());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
